import React, { useState, useRef, useEffect } from 'react';
import { OutsideAlerter } from './OutsideAlerter';
import './simpleSelect.scss';
import classNames from 'classnames';

type Option = {
  value: string;
  label: string;
};

type props = {
  selectedOption: Option;
  handleChange: (v: Option) => void;
  options: Option[];
  isDisabled?: boolean;
};

const SimpleSelect = ({ selectedOption, handleChange, options, isDisabled = false }: props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(selectedOption);
  const toggle = () => setIsOpen(!isOpen);
  const selectRef = useRef(null);

  useEffect(() => {
    setSelected(selectedOption);
  }, [selectedOption]);

  const onOptionClicked = (value: Option) => () => {
    handleChange(value);
    setIsOpen(false);
  };

  const renderOptions = () => {
    return options?.map((option: Option, i: number) => (
      <div className="select-option" key={i} onClick={onOptionClicked(option)}>
        {option.label}
      </div>
    ));
  };

  const hideOptions = () => setIsOpen(false);

  return (
    <div className={`simple-select ${isOpen ? 'focus' : ''}`} ref={selectRef}>
      <OutsideAlerter onOutsideClick={hideOptions} refsList={[selectRef]}>
        <div className={classNames('select-header', { disabled: isDisabled })} onClick={toggle}>
          <span>{selected.label}</span>
          <span className={`caret ${isOpen ? 'rotate' : ''}`}></span>
        </div>
      </OutsideAlerter>
      {isOpen && <div className="select-options">{renderOptions()}</div>}
    </div>
  );
};

export default SimpleSelect;
